import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import * as Icon from "react-feather";

// Modal Video
import ModalVideo from "react-modal-video";
import "../../../node_modules/react-modal-video/scss/modal-video.scss";

// Import components
import Navbar from "../../component/Navbar";
import Hero from "../../component/Hero";
import Services from "../../component/Services";
import CTASection from "../../component/CTASection";
import AgencyProject from "../../component/AgencyProject";
import Team from "../../component/Team";
import JobListings from "../../component/JobListings";
import News from "../../component/News";
import Contact from "../../component/Contact";
import Footer from "../../component/Footer";
import { teamData } from "../../constants/teamData";

export default function Startup() {
  const [videoModal, setModal] = useState(false);
  const [isOpen, setMenu] = useState(true);
  const [isVideoVisible, setIsVideoVisible] = useState(false);

  window.addEventListener("scroll", windowScroll);

  // Intersection Observer for video auto-play
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVideoVisible(true);
          } else {
            setIsVideoVisible(false);
          }
        });
      },
      { threshold: 0.3 }
    );

    const ctaSection = document.getElementById("cta-section");
    if (ctaSection) {
      observer.observe(ctaSection);
    }

    return () => {
      if (ctaSection) {
        observer.unobserve(ctaSection);
      }
    };
  }, []);

  const team = Object.values(teamData);

  /**
   * Window scroll
   */
  function windowScroll() {
    const navbar = document.getElementById("navbar");

    if (
      document.body.scrollTop >= 50 ||
      document.documentElement.scrollTop >= 50
    ) {
      navbar.classList.add("nav-sticky");
    } else {
      navbar.classList.remove("nav-sticky");
    }

    const mybutton = document.getElementById("back-to-top");

    if (
      document.body.scrollTop >= 500 ||
      document.documentElement.scrollTop >= 500
    ) {
      mybutton.classList.add("block");
    } else {
      mybutton.classList.add("none");
    }
  }

  const toggleMenu = () => {
    setMenu(!isOpen);
  };

  return (
    <>
      <div>
        <Navbar isOpen={isOpen} toggleMenu={toggleMenu} />
        <Hero />
        <Services setModal={setModal} />
        <CTASection isVideoVisible={isVideoVisible} />
        <AgencyProject />
        {/* <Pricing /> */}
        <News />
        <Team team={team} />
        <JobListings />
        <Contact />
        <Footer />

        {/* Back to top */}
        <Link
          to="home"
          id="back-to-top"
          className="back-to-top rounded-pill fs-5"
        >
          <Icon.ArrowUp className="fea icon-sm icons align-middle" />
        </Link>
        {/* Back to top  */}
      </div>

      {/* popup video */}
      <ModalVideo
        channel="youtube"
        isOpen={videoModal}
        videoId="yba7hPeTSjk"
        onClose={() => setModal(false)}
      />
    </>
  );
}
